import { useEffect } from 'react'

export function useDefaultFont() {
  useEffect(() => {
    const loadFonts = async () => {
      try {
        const interFont = new FontFace('Inter', 'url(/common/fonts/Inter-VariableFont.ttf)', {
          style: 'normal',
          weight: '100 900',
        })

        const interItalicFont = new FontFace(
          'Inter',
          'url(/common/fonts/Inter-Italic-VariableFont.ttf)',
          { style: 'italic', weight: '100 900' }
        )

        await Promise.all([interFont.load(), interItalicFont.load()])
        ;(document.fonts as any).add(interFont)
        ;(document.fonts as any).add(interItalicFont)
      } catch (error) {
        console.warn('Failed to load Inter fonts:', error)
      }
    }

    loadFonts()
  }, [])
}
